import { Datatype } from '@framework/engine/schema/expressions/datatype/Datatype.ts';
import {
  type IReference,
  ReferenceType,
} from '@framework/engine/schema/expressions/references/IReference.ts';
import { ReferencePathDirection } from '@framework/engine/schema/expressions/references/IReferencePath.ts';
import { type ISessionData } from './ISessionData.ts';

function createSubmitterSessionReference(
  datatype: Datatype.String | Datatype.Number | Datatype.Date,
  code: string,
  label: string,
): IReference {
  return {
    type: ReferenceType.Session,
    id: `richiedente_${code}`,
    code,
    label,
    path: [
      { direction: ReferencePathDirection.Absolute, code: 'session' },
      { direction: ReferencePathDirection.Child, code: 'richiedente' },
    ],
    field: {
      type: datatype,
    },
    group: 'Utente Attivo',
  };
}

function createSubmitterAdditionalDataReference(
  datatype: Datatype.String | Datatype.Number | Datatype.Date,
  code: string,
  label: string,
): IReference {
  return {
    type: ReferenceType.Session,
    id: `additional_data_${code}`,
    code,
    label,
    path: [
      { direction: ReferencePathDirection.Absolute, code: 'session' },
      {
        direction: ReferencePathDirection.Child,
        code: 'datiAnagraficiAggiuntivi' satisfies keyof ISessionData,
      },
    ],
    field: {
      type: datatype,
    },
    group: 'Utente Attivo',
  };
}

/**
 * Verificare sempre che siano allineate con `ISessionData`.
 * Il prefisso è sempre `session`
 */
export function getSessionDataReferences(): IReference[] {
  return [
    {
      type: ReferenceType.Session,
      id: 'data_compilazione',
      code: 'data_compilazione',
      label: 'Data compilazione',
      path: [{ direction: ReferencePathDirection.Absolute, code: 'session' }],
      field: {
        type: Datatype.Date,
      },
    },
    createSubmitterSessionReference(
      Datatype.String,
      'nome',
      'Utente Attivo: Nome',
    ),
    createSubmitterSessionReference(
      Datatype.String,
      'cognome',
      'Utente Attivo: Cognome',
    ),
    createSubmitterSessionReference(
      Datatype.String,
      'email',
      'Utente Attivo: Email',
    ),
    /** @deprecated */
    // createSubmitterSessionReference(
    //   Datatype.String,
    //   'codiceFiscale',
    //   'Utente Attivo: Codice fiscale',
    // ),
    createSubmitterSessionReference(
      Datatype.String,
      'codice_fiscale',
      'Utente Attivo: Codice fiscale',
    ),
    // Dati anagrafici aggiuntivi (SPID)
    createSubmitterAdditionalDataReference(
      Datatype.Date,
      'dataNascita',
      'Utente Attivo: Data di nascita',
    ),
    createSubmitterAdditionalDataReference(
      Datatype.String,
      'genere',
      'Utente Attivo: Genere',
    ),
    createSubmitterAdditionalDataReference(
      Datatype.String,
      'codiceLuogoNascita',
      'Utente Attivo: Codice luogo di nascita',
    ),
    createSubmitterAdditionalDataReference(
      Datatype.String,
      'denominazioneLuogoNascita',
      'Utente Attivo: Denominazione luogo di nascita',
    ),
    createSubmitterAdditionalDataReference(
      Datatype.String,
      'codiceProvinciaNascita',
      'Utente Attivo: Codice provincia di nascita',
    ),
    createSubmitterAdditionalDataReference(
      Datatype.String,
      'denominazioneProvinciaNascita',
      'Utente Attivo: Denominazione provincia di nascita',
    ),
    createSubmitterAdditionalDataReference(
      Datatype.String,
      'paeseDiNascita',
      'Utente Attivo: Paese di nascita',
    ),
    createSubmitterAdditionalDataReference(
      Datatype.String,
      'indirizzo',
      'Utente Attivo: Indirizzo',
    ),
    createSubmitterAdditionalDataReference(
      Datatype.String,
      'indirizzoDigitale',
      'Utente Attivo: Indirizzo digitale',
    ),
    createSubmitterAdditionalDataReference(
      Datatype.String,
      'numeroCellulare',
      'Utente Attivo: Numero di cellulare',
    ),
    createSubmitterAdditionalDataReference(
      Datatype.String,
      'codiceIva',
      'Utente Attivo: Partita IVA',
    ),
    createSubmitterAdditionalDataReference(
      Datatype.String,
      'sedeLegale',
      'Utente Attivo: Sede legale',
    ),
    createSubmitterAdditionalDataReference(
      Datatype.String,
      'indirizzoDomicilioFisico',
      'Utente Attivo: Indirizzo domicilio fisico',
    ),
    createSubmitterAdditionalDataReference(
      Datatype.String,
      'capDomicilioFisico',
      'Utente Attivo: CAP domicilio fisico',
    ),
    createSubmitterAdditionalDataReference(
      Datatype.String,
      'comuneDomicilioFisico',
      'Utente Attivo: Comune domicilio fisico',
    ),
    createSubmitterAdditionalDataReference(
      Datatype.String,
      'provinciaDomicilioFisico',
      'Utente Attivo: Provincia domicilio fisico',
    ),
    createSubmitterAdditionalDataReference(
      Datatype.String,
      'nazioneDomicilioFisico',
      'Utente Attivo: Nazione domicilio fisico',
    ),
    // Carta d'identità
    createSubmitterAdditionalDataReference(
      Datatype.String,
      'tipologiaCi',
      "Utente Attivo: Tipologia carta d'identità",
    ),
    createSubmitterAdditionalDataReference(
      Datatype.String,
      'idCi',
      "Utente Attivo: ID carta d'identità",
    ),
    createSubmitterAdditionalDataReference(
      Datatype.String,
      'comuneRilascioCi',
      "Utente Attivo: Comune rilascio carta d'identità",
    ),
    createSubmitterAdditionalDataReference(
      Datatype.Date,
      'dataRilascioCi',
      "Utente Attivo: Data rilascio carta d'identità",
    ),
    createSubmitterAdditionalDataReference(
      Datatype.Date,
      'dataScadenzaCi',
      "Utente Attivo: Data scadenza carta d'identità",
    ),
  ];
}
